import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert, Button, Form, Input, message, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { apiCreateDepositLink } from '../../../api/account';
import { formatPrice } from '../../../utils/format';
import { useIsMobileHook } from '../../../utils/WindowHooks';
import './DepositModal.scss';

const DepositModal = ({ visible, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [depositLink, setDepositLink] = useState(null);
  const [priceDeposit, setPriceDeposit] = useState(0);
  const isMobile = useIsMobileHook(768);

  useEffect(() => {
    if (visible) {
      form.resetFields();
      setDepositLink(null);
      setPriceDeposit(0);
      setLoading(false);
    }
  }, [visible, form]);

  const handleAmountChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    setPriceDeposit(parseInt(numericValue, 10) || 0);
  };

  const handleCreateLink = async () => {
    try {
      await form.validateFields();

      if (priceDeposit < 100) {
        message.error('Por favor, insira um valor maior que R$ 1,00.');
        return;
      }

      setLoading(true);

      const payload = {
        name: form.getFieldValue('description'),
        amount: priceDeposit / 100,
      };

      const response = await apiCreateDepositLink(payload);
      setDepositLink(`https://painel.dlpay.cloud/pagar/${response.id}`);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error('Erro ao criar link de depósito. Tente novamente.');
      console.error(error);
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(depositLink);
    message.success('Link copiado para a área de transferência!');
  };

  const handleOpenLink = () => {
    window.open(depositLink, '_blank');
  };

  return (
    <Modal
      className="deposit-modal"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={isMobile ? '95%' : 600}
    >
      <h2 className="ant-modal-title">{depositLink ? 'Link de depósito criado com sucesso!' : 'Depositar'}</h2>

      {!depositLink ? (
        <div className="body-deposit">
          <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
            <div className="subtitle-body">
              <h3>Criar link de depósito</h3>
            </div>

            <Form.Item
              name="description"
              label="Descrição do depósito"
              rules={[
                { required: true, message: 'Por favor, insira uma descrição!' },
                { max: 32, message: 'A descrição deve ter no máximo 32 caracteres!' }
              ]}
            >
              <Input
                placeholder="Ex: Venda presencial"
                maxLength={32}
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Valor do depósito
                  <InfoCircleOutlined style={{ color: "#1890ff", marginLeft: 8 }} />
                </span>
              }
              style={{ width: '100%', maxWidth: 300 }}
              rules={[{ required: true, message: 'Por favor, insira o valor!' }]}
            >
              <Input
                value={formatPrice(priceDeposit / 100)}
                onChange={handleAmountChange}
                placeholder="R$ 0,00"
              />
            </Form.Item>

            <div className='container-buttons' style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 40 }}>
              <Button style={{ marginRight: 8 }} onClick={onClose} danger>
                Cancelar
              </Button>
              <Button type="primary" onClick={handleCreateLink} loading={loading}>
                Criar link de depósito
              </Button>
            </div>
          </Form>
        </div>
      ) : (
        <div className="deposit-success">
          <Alert
            message="Informações importantes"
            description={
              <div>
                <p>Uma vez que o link for pago, pode levar até <strong>48 horas</strong> para o banco reconhecer o pagamento.</p>
                <p>Este é um processo totalmente automatizado, nenhuma ação adicional é necessária.</p>
                <p className="last-line">A empresa processadora de pagamentos pode cobrar pequenas taxas para processar a transação.</p>
              </div>
            }
            type="info"
            showIcon
            icon={<InfoCircleOutlined style={{ fontSize: 16 }} />}
            className="deposit-alert"
          />

          <div className="link-container">
            <label className="link-label">Link de pagamento</label>
            <div className="link-input-wrapper">
              <Input
                value={depositLink}
                readOnly
                className="deposit-link-input"
              />
              <Button
                onClick={handleCopyLink}
                className="copy-link-button"
              >
                Copiar
              </Button>
            </div>
          </div>

          <div className='success-buttons-container'>
            <Button onClick={onClose}>
              Fechar
            </Button>
            <Button
              type="primary"
              onClick={handleOpenLink}
            >
              Pagar agora
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default DepositModal;
